import type { SVGProps } from 'react';
const SvgCollectionsBookmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#collections_bookmark_svg__a)">
      <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6Z" />
      <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 10-2.5-1.5L15 12V4h5v8Z" />
    </g>
    <defs>
      <clipPath id="collections_bookmark_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCollectionsBookmark;
